<template>
  <div>
    <van-overlay :show="show" @click="show = false" />

    <!-- 导航栏 -->
    <div class="navbar">
      <div class="top">
        <img class="logo" src="@/assets/logo.png" @click="selectItem('/')" />

        <img class="menu" src="@/assets/menu.png" alt="" @click="open" />
      </div>

      <div class="bottom" v-show="show">
        <div
          v-for="(item, index) in titles"
          :key="index"
          @click="selectItem(item.path, item.type)"
          class="item"
        >
          <p>{{ item.title }}</p>
          <div class="divide-line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import bus from "@/event-bus/eventBus.js";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

const show = ref(false);
const router = useRouter(); // ✅ 获取 Vue Router 实例

const titles = [
  {
    title: "PDF转Word",
    active: false,
    path: "/convert-scans-to-editable-docs",
    type: "pdf",
  },
  {
    title: "OCR文字识别",
    active: false,
    path: "/convert-scans-to-editable-docs",
    type: "ocr",
  },
  {
    title: "表格格式保留",
    active: false,
    path: "/convert-scans-to-editable-docs",
    type: "table",
  },{
    title: "定价",
    active: false,
    path: "/price",
  },
  { title: "使用场景", active: false, path: "/use-cases" },
  { title: "帮助中心", active: false, path: "/faq" },
];

const open = () => {
  show.value = !show.value;
};
const selectItem = (path, type) => {
  show.value = false;
  router.push({
    path: path,
    query: { type: type },
  });
};
</script>

<style lang="less" scoped>
.navbar {
  position: fixed;
  width: 375px;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: #fff;
  height: 66px;

  .top {
    display: flex;
    justify-content: space-between;
    .logo {
      width: 200px;
      margin-left: 20px;
    }

    .menu {
      align-self: center;
      width: 48px;
      margin-right: 20px;
    }
  }

  .bottom {
    height: 100%;
    .item {
      height: 64px;
      color: #0c0c0c;
      background-color: #fff;
      font-size: 16px;
      font-weight: 400;
      padding-left: 20px;
      line-height: 64px;
      p {
        border-bottom: 1px solid #ebebeb;
        margin: 0 20px;
      }
    }
  }
}
</style>